import { useTranslation } from "react-i18next";
import React, { useEffect, useMemo, useState } from "react";
import { colorService } from "../../Services/color.service";
import { vehicleGroupService } from "../../Services/vehicle.group.service";
import { useDispatch } from "react-redux";
// import {
//     GridComponent,
//     Page,
//     Inject,
//     ColumnDirective,
//     ColumnsDirective,
//     Filter,
// } from "@syncfusion/ej2-react-grids";
import Spinner from "../Components/Spinner";
import { useLocation, useNavigate } from "react-router-dom";
// import ToastError from "../Components/ToastError";
// import DeleteModal from "../Components/Modals/Delete-modal";
// import { select } from "@syncfusion/ej2-base";
import { FaCheck } from "react-icons/fa";
import { IoMdArrowBack } from "react-icons/io";
import { AiOutlineExclamationCircle } from "react-icons/ai";
import { IoCheckmarkCircleOutline } from "react-icons/io5";
import { IoIosAlert } from "react-icons/io";
import { configsService } from "../../Services/configs.service";
import { ToastComponent } from "../Components/ToastComponent";
import ReportConfigList, {
  FREQUENCIA,
  TIPO_EXCEL,
} from "../../components/ReportConfig/ReportConfigList";


export default function VehiclesConfig() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const { item } = location.state || {};

  const getStorageKey = () => `vehicleConfig_${item?.vehicleGroupId}`;

  const loadStateFromStorage = () => {
    const savedState = localStorage.getItem(getStorageKey());
    if (savedState) {
      return JSON.parse(savedState);
    }
    return {};
  };

  const initialStoredState = loadStateFromStorage();

  const [isLoading, setIsLoading] = useState(true);
  const [listCollor, setListCollor] = useState([]);

  const [selectedColor, setSelectedColor] = useState(
    initialStoredState.selectedColor || ""
  );
  const [selectedId, setSelectedId] = useState(
    initialStoredState.selectedId || ""
  );
  const [group, setGroup] = useState();

  const [kmzFlag, setKmzFlag] = useState(initialStoredState.kmzFlag || false);
  const [fenceFlag, setFenceFlag] = useState(
    initialStoredState.fenceFlag || false
  );
  const [visitFlag, setVisitFlag] = useState(
    initialStoredState.visitFlag || false
  );
  const [riskAreaFlag, setRiskAreaFlag] = useState(
    initialStoredState.riskAreaFlag || false
  );
  const [strechesFlag, setStrechesFlag] = useState(
    initialStoredState.strechesFlag || false
  );
  const [toastParams, setToastParams] = useState("");
  const [isSaving, setIsSaving] = useState(false);
  const [loadingButtons, setLoadingButtons] = useState({});
  const [refreshEmails, setRefreshEmails] = useState(false);

  const [relatorios, setRelatorios] = useState(
    initialStoredState.relatorios || {
      kmz: false,
      movimentacao: false,
      pontoDeVista: false,
      areaDeRisco: false,
      cercaEletronica: false,
      visitsSummaryXlsPeriod: false,
      visitsSummaryPdfPeriod: false,
      visitsAmountPdfPeriod: false,
      visitsAmountXlsPeriod: false,
      speedSummaryPdfPeriod: false,
      speedSummaryXlsPeriod: false,
      maintenanceSummaryPdfPeriod: false,
      maintenanceSummaryXlsPeriod: false,
    }
  );

  const [archives, setArchives] = useState(
    initialStoredState.archives || {
      archiveKmz: "K",
      archiveMovimentacao: "P",
      archivePontoDeVista: "P",
      archiveAreaDeRisco: "P",
      archiveCercaEletronica: "P",
    }
  );

  const [movementForm, setMovementForm] = useState(
    initialStoredState.movementForm || {
      weekdays: {
        flag: false,
        start: "08:00",
        end: "18:00",
      },
      saturday: {
        flag: false,
        start: "08:00",
        end: "18:00",
      },
      sunday: {
        flag: false,
        start: "08:00",
        end: "18:00",
      },
      emailNotificationFlag: false,
      attachmentFormat: "pdf",
    }
  );

  const [speedForm, setSpeedForm] = useState(
    initialStoredState.speedForm || {
      urban: {
        flag: false,
        value: "30",
      },
      highway: {
        flag: false,
        value: "30",
      },
      emailNotificationFlag: false,
      attachmentFormat: "P",
    }
  );

  const buildReportConfigFromApi = (groupData) => {
    const mapPeriod = (value) =>
      value === "S" ? FREQUENCIA.SEMANAL : FREQUENCIA.DIARIO;

    return [
      {
        id: "positionKmzPeriod",
        ativo: !!groupData?.positionKmzPeriod,
        frequencia: mapPeriod(groupData?.positionKmzPeriod),
      },
      {
        id: "positionPdfPeriod",
        ativo: !!groupData?.positionPdfPeriod,
        frequencia: mapPeriod(groupData?.positionPdfPeriod),
      },
      {
        id: "positionXlsPeriod",
        ativo: !!groupData?.positionXlsPeriod,
        frequencia: mapPeriod(groupData?.positionXlsPeriod),
        tipoExcel: TIPO_EXCEL.ABA_UNICA,
      },
      {
        id: "activitySummaryPdfPeriod",
        ativo: !!groupData?.activitySummaryPdfPeriod,
        frequencia: mapPeriod(groupData?.activitySummaryPdfPeriod),
      },
      {
        id: "activitySummaryXlsPeriod",
        ativo: !!groupData?.activitySummaryXlsPeriod,
        frequencia: mapPeriod(groupData?.activitySummaryXlsPeriod),
        tipoExcel: TIPO_EXCEL.ABA_UNICA,
      },
      {
        id: "excerptSummaryPdfPeriod",
        ativo: !!groupData?.excerptSummaryPdfPeriod,
        frequencia: mapPeriod(groupData?.excerptSummaryPdfPeriod),
      },
      {
        id: "excerptSummaryXlsPeriod",
        ativo: !!groupData?.excerptSummaryXlsPeriod,
        frequencia: mapPeriod(groupData?.excerptSummaryXlsPeriod),
        tipoExcel: TIPO_EXCEL.ABA_UNICA,
      },
      {
        id: "visitsSummaryPdfPeriod",
        ativo: !!groupData?.summaryVisitsByVehiclesPdfPeriod,
        frequencia: mapPeriod(groupData?.summaryVisitsByVehiclesPdfPeriod),
      },
      {
        id: "visitsSummaryXlsPeriod",
        ativo: !!groupData?.summaryVisitsByVehiclesXlsPeriod,
        frequencia: mapPeriod(groupData?.summaryVisitsByVehiclesXlsPeriod),
        tipoExcel: TIPO_EXCEL.ABA_UNICA,
      },
      {
        id: "visitsAmountPdfPeriod",
        ativo:
          !!(
            groupData?.visitVehicleSummaryPdfPeriod ??
            groupData?.vehicleVisitSummaryPdfPeriod
          ),
        frequencia: mapPeriod(
          groupData?.visitVehicleSummaryPdfPeriod ??
          groupData?.vehicleVisitSummaryPdfPeriod
        ),
      },
      {
        id: "visitsAmountXlsPeriod",
        ativo:
          !!(
            groupData?.visitVehicleSummaryXlsPeriod ??
            groupData?.vehicleVisitSummaryXlsPeriod
          ),
        frequencia: mapPeriod(
          groupData?.visitVehicleSummaryXlsPeriod ??
          groupData?.vehicleVisitSummaryXlsPeriod
        ),
        tipoExcel: TIPO_EXCEL.ABA_UNICA,
      },
      {
        id: "speedSummaryPdfPeriod",
        ativo: !!groupData?.summaryHighspeedPDFPeriod,
        frequencia: mapPeriod(groupData?.summaryHighspeedPDFPeriod),
      },
      {
        id: "speedSummaryXlsPeriod",
        ativo: !!groupData?.summaryHighspeedXLSPeriod,
        frequencia: mapPeriod(groupData?.summaryHighspeedXLSPeriod),
        tipoExcel: TIPO_EXCEL.ABA_UNICA,
      },
      {
        id: "maintenanceSummaryPdfPeriod",
        ativo:
          !!(
            groupData?.summaryMaintenancesPdfPeriod ??
            groupData?.maintenanceSummaryPdfPeriod
          ),
        frequencia: mapPeriod(
          groupData?.summaryMaintenancesPdfPeriod ??
          groupData?.maintenanceSummaryPdfPeriod
        ),
      },
      {
        id: "maintenanceSummaryXlsPeriod",
        ativo:
          !!(
            groupData?.summaryMaintenancesXlsPeriod ??
            groupData?.maintenanceSummaryXlsPeriod
          ),
        frequencia: mapPeriod(
          groupData?.summaryMaintenancesXlsPeriod ??
          groupData?.maintenanceSummaryXlsPeriod
        ),
        tipoExcel: TIPO_EXCEL.ABA_UNICA,
      },
    ];
  };

  const reportItems = useMemo(
    () => [
      {
        id: "positionKmzPeriod",
        nome: "Envio de posicionamento KMZ",
        tipo: "KMZ",
        codeReport: 12,
      },
      {
        id: "positionPdfPeriod",
        nome: "Envio de posicionamento PDF",
        tipo: "PDF",
        codeReport: 11,
      },
      {
        id: "positionXlsPeriod",
        nome: "Envio de posicionamento Excel",
        tipo: "EXCEL",
        codeReport: 10,
      },
      {
        id: "activitySummaryPdfPeriod",
        nome: "Resumo de atividades PDF",
        tipo: "PDF",
        codeReport: 16,
      },
      {
        id: "activitySummaryXlsPeriod",
        nome: "Resumo de atividades Excel",
        tipo: "EXCEL",
        codeReport: 15,
      },
      {
        id: "excerptSummaryPdfPeriod",
        nome: "Resumo de movimentação / trechos PDF",
        tipo: "PDF",
        codeReport: 21,
      },
      {
        id: "excerptSummaryXlsPeriod",
        nome: "Resumo de movimentação / trechos Excel",
        tipo: "EXCEL",
        codeReport: 20,
      },
      {
        id: "visitsSummaryXlsPeriod",
        nome: "Relatório de visitas por veículos XLS",
        tipo: "EXCEL",
        codeReport: 25,
      },
      {
        id: "visitsSummaryPdfPeriod",
        nome: "Relatório de visitas por veículos PDF",
        tipo: "PDF",
        codeReport: 26,
      },
      {
        id: "visitsAmountPdfPeriod",
        nome: "Relatório de veículos por visitas PDF",
        tipo: "PDF",
        codeReport: 31,
      },
      {
        id: "visitsAmountXlsPeriod",
        nome: "Relatório de veículos por visitas XLS",
        tipo: "EXCEL",
        codeReport: 30,
      },
      {
        id: "speedSummaryPdfPeriod",
        nome: "Velocidade PDF",
        tipo: "PDF",
        codeReport: 36,
      },
      {
        id: "speedSummaryXlsPeriod",
        nome: "Velocidade XLS",
        tipo: "EXCEL",
        codeReport: 35,
      },
      {
        id: "maintenanceSummaryPdfPeriod",
        nome: "Manutenção PDF",
        tipo: "PDF",
        codeReport: 27,
      },
      {
        id: "maintenanceSummaryXlsPeriod",
        nome: "Manutenção XLS",
        tipo: "EXCEL",
        codeReport: 28,
      },
    ],
    []
  );

  const [reportConfigPayload, setReportConfigPayload] = useState(
    initialStoredState.reportConfigPayload || []
  );

  const [initialReportConfig, setInitialReportConfig] = useState(
    initialStoredState.reportConfigPayload || []
  );

  useEffect(() => {
    if (item?.vehicleGroupId) {
      const stateToSave = {
        selectedId,
        selectedColor,
        kmzFlag,
        fenceFlag,
        visitFlag,
        riskAreaFlag,
        strechesFlag,
        relatorios,
        archives,
        movementForm,
        speedForm,
        reportConfigPayload,
      };
      localStorage.setItem(getStorageKey(), JSON.stringify(stateToSave));
    }
  }, [
    // Lista de dependências: este efeito roda sempre que um desses valores for alterado.
    selectedId,
    selectedColor,
    kmzFlag,
    fenceFlag,
    visitFlag,
    riskAreaFlag,
    strechesFlag,
    relatorios,
    archives,
    movementForm,
    speedForm,
    reportConfigPayload,
    item,
  ]);

  // Gera o array de opções de 30 a 120 de 10 em 10
  const optionsUrban = [];
  for (let i = 30; i <= 120; i += 10) {
    optionsUrban.push(i);
  }

  const optionsRod = [];
  for (let i = 30; i <= 120; i += 10) {
    optionsRod.push(i);
  }

  const handleToggle = (key) => {
    setRelatorios((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };

  const handleToggleArchives = (key, value) => {
    setArchives((prev) => ({
      ...prev,
      [key]: value,
    }));

    console.log(archives);
  };

  console.log(item); // agora item existe!

  const LEGACY_REPORT_TYPES = useMemo(
    () => [
      {
        key: "pontoDeVista",
        codeReport: 3,
        nome: "Envio de relatório de ponto de visita, controle e passagem",
      },
      {
        key: "areaDeRisco",
        codeReport: 4,
        nome: "Envio de relatório de área de risco",
      },
      {
        key: "cercaEletronica",
        codeReport: 5,
        nome: "Envio de relatório de condução em cerca eletrônica",
      },
    ],
    []
  );

  const REPORT_TYPES = useMemo(
    () => [
      ...reportItems.map((item) => ({
        key: item.id,
        codeReport: item.codeReport,
        nome: item.nome,
      })),
      ...LEGACY_REPORT_TYPES,
    ],
    [reportItems, LEGACY_REPORT_TYPES]
  );

  // Toggle to show/hide legacy report toggles (UI in image)
  const SHOW_LEGACY_REPORTS = false;

  const initialReports = REPORT_TYPES.map((type) => type.key);

  const buildInitialState = () => {
    const state = {};
    REPORT_TYPES.forEach((type) => {
      state[type.key] = {
        codeReport: type.codeReport,
        email: "",
        list: [],
        error: "",
      };
    });
    return state;
  };

  const [emailsByReport, setEmailsByReport] = useState(buildInitialState);

  const extractEmailText = (value) => {
    if (typeof value === "string") {
      return value;
    }

    if (value && typeof value === "object") {
      return (
        value.email ||
        value.address ||
        value.value ||
        value.text ||
        value.label ||
        ""
      );
    }

    return "";
  };

  const normalizeEmailList = (response) => {
    const responseList =
      (Array.isArray(response) && response) ||
      (Array.isArray(response?.items) && response.items) ||
      (Array.isArray(response?.result) && response.result) ||
      (Array.isArray(response?.data) && response.data) ||
      (response && typeof response === "object" ? [response] : []);

    return responseList
      .map((entry) => {
        const rawIsValid = entry?.isValid ?? entry?.validated ?? entry?.isValidated;
        const normalizedEmail = extractEmailText(
          entry?.email ?? entry?.address ?? entry?.value ?? entry?.text ?? entry?.label
        );

        return {
          id:
            entry?.id ??
            entry?.emailId ??
            entry?.emailConfigurationId ??
            entry?.vehicleGroupEmailId,
          email: normalizedEmail,
          isValid:
            rawIsValid === "S" || rawIsValid === true
              ? "S"
              : rawIsValid === "N" || rawIsValid === false
                ? "N"
                : "N",
          statusText:
            rawIsValid === "N" || rawIsValid === false ? "Pendente" : "",
        };
      })
      .filter((entry) => entry.id && entry.email);
  };

  const fetchEmails = async () => {
    if (!item?.vehicleGroupId) {
      return;
    }

    try {
      const promises = REPORT_TYPES.map(async (type) => {
        let response = await configsService.fetchEmailConfiguration(
          item.vehicleGroupId,
          type.codeReport
        );

        return response;
      });

      const responses = await Promise.all(promises);

      const grouped = {};
      REPORT_TYPES.forEach((type, index) => {
        grouped[type.key] = {
          codeReport: type.codeReport,
          email: "",
          error: "",
          list: normalizeEmailList(responses[index]),
        };
      });

      setEmailsByReport(grouped);
    } catch (error) {
      console.error("Erro ao carregar emails:", error);
    }
  };

  useEffect(() => {
    if (item?.vehicleGroupId) {
      fetchEmails();
    }

    const handleRefresh = () => {
      if (document.visibilityState === "visible") {
        fetchEmails();
      }
    };

    window.addEventListener("focus", fetchEmails);
    document.addEventListener("visibilitychange", handleRefresh);

    return () => {
      window.removeEventListener("focus", fetchEmails);
      document.removeEventListener("visibilitychange", handleRefresh);
    };
  }, [item?.vehicleGroupId, REPORT_TYPES]);

  //buscar o grupo
  useEffect(() => {
    const fetchData = async () => {
      try {
        // Carrega configuração de relatórios do endpoint
        const reportsConfig = await configsService.fetchGroupReportsConfiguration(
          item.vehicleGroupId
        );
        console.log("Reports Configuration:", reportsConfig);

        if (reportsConfig && Array.isArray(reportsConfig) && reportsConfig.length > 0) {
          const groupData = reportsConfig[0];
          setGroup(groupData);

          // Atribui os valores do grupo aos filtros
          if (groupData.colorId) {
            setSelectedId(groupData.colorId);
            const colorObj = listCollor.find(c => c.colorId == groupData.colorId);
            if (colorObj) {
              setSelectedColor(colorObj.hex);
            }
          }

          // Atribui flags booleanas
          setKmzFlag(groupData.emailKmzCheckFlag === 'S');
          setFenceFlag(groupData.emailFenceCheckFlag === 'S');
          setVisitFlag(groupData.emailVisitCheckFlag === 'S');
          setRiskAreaFlag(groupData.emailRiskAreaCheckFlag === 'S');
          setStrechesFlag(groupData.emailSegmentCheckFlag === 'S');

          // Atribui configurações de relatórios
          setRelatorios(prev => ({
            ...prev,
            kmz: groupData.emailKmzCheckFlag === 'S',
            movimentacao: groupData.emailMovementCheckFlag === 'S',
            pontoDeVista: groupData.emailVisitCheckFlag === 'S',
            areaDeRisco: groupData.emailRiskAreaCheckFlag === 'S',
            cercaEletronica: groupData.emailFenceCheckFlag === 'S',
          }));

          // Atribui configurações de arquivos
          setArchives(prev => ({
            ...prev,
            archiveKmz: groupData.emailKmzAttachmentFormat || 'K',
            archiveMovimentacao: groupData.emailMovementCheckAttachmentFormat || 'P',
            archivePontoDeVista: 'P',
            archiveAreaDeRisco: 'P',
            archiveCercaEletronica: 'P',
          }));

          // Atribui configurações de movimento (respeita localStorage se existir)
          const movementFormData = initialStoredState.movementForm || {
            weekdays: {
              flag: groupData.movementCheckMonToFriFlag === 'S',
              start: groupData.movementCheckMonToFriStart?.substring(0, 5) || '08:00',
              end: groupData.movementCheckMonToFriEnd?.substring(0, 5) || '18:00',
            },
            saturday: {
              flag: groupData.movementCheckSatFlag === 'S',
              start: groupData.movementCheckSatStart?.substring(0, 5) || '08:00',
              end: groupData.movementCheckSatEnd?.substring(0, 5) || '18:00',
            },
            sunday: {
              flag: groupData.movementCheckSunFlag === 'S',
              start: groupData.movementCheckSunStart?.substring(0, 5) || '08:00',
              end: groupData.movementCheckSunEnd?.substring(0, 5) || '18:00',
            },
            emailNotificationFlag: groupData.emailMovementCheckFlag === 'S',
            attachmentFormat: groupData.emailMovementCheckAttachmentFormat || 'P',
          };
          setMovementForm(movementFormData);

          // Atribui configurações de velocidade (respeita localStorage se existir)
          const speedFormData = initialStoredState.speedForm || {
            urban: {
              flag: groupData.urbanSpeedCheckFlag === 'S',
              value: groupData.urbanSpeedCheckValue?.toString() || '30',
            },
            highway: {
              flag: groupData.roadSpeedCheckFlag === 'S',
              value: groupData.roadSpeedCheckValue?.toString() || '30',
            },
            emailNotificationFlag: groupData.emailSpeedCheckFlag === 'S',
            attachmentFormat: groupData.emailSpeedCheckAttachmentFormat || 'P',
          };
          setSpeedForm(speedFormData);

          const storedReportConfig = initialStoredState.reportConfigPayload;
          if (Array.isArray(storedReportConfig) && storedReportConfig.length > 0) {
            setInitialReportConfig(storedReportConfig);
            setReportConfigPayload(storedReportConfig);
            // also initialize relatorios from stored config if present
            setRelatorios((prev) => ({
              ...prev,
              ...storedReportConfig.reduce((acc, cfg) => {
                acc[cfg.id] = !!cfg.ativo;
                return acc;
              }, {}),
            }));
          } else {
            const mappedReportConfig = buildReportConfigFromApi(groupData);
            setInitialReportConfig(mappedReportConfig);
            setReportConfigPayload(mappedReportConfig);
            // Preenche os flags de relatorios a partir da configuração retornada
            setRelatorios((prev) => ({
              ...prev,
              ...mappedReportConfig.reduce((acc, cfg) => {
                acc[cfg.id] = !!cfg.ativo;
                return acc;
              }, {}),
            }));
          }
        }
      } catch (error) {
        console.error("Erro ao buscar as grupos:", error);
      } finally {
        setIsLoading(false);
      }
    };
    fetchData();
  }, [item.vehicleGroupId, listCollor]);

  //buscar as cores
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await colorService.list();
        if (response) {
          setListCollor(response);
        }
      } catch (error) {
        console.error("Erro ao buscar as cores:", error);
      } finally {
        setIsLoading(false);
      }
    };
    fetchData();
  }, []);

  useEffect(() => {
    dispatch({ type: "title", value: "Configuração do grupo" });
  }, [dispatch]);

  const handleChangeCollor = (e) => {
    const colorId = e.target.value;
    const colorObj = listCollor.find((c) => c.colorId == colorId);
    setSelectedColor(colorObj?.hex || "");
    setSelectedId(colorId);
  };

  const handleCancel = () => {
    navigate(-1); // 👈 volta para a página anterior
  };

  const onSubmit = async (idColor) => {
    const getFlag = (value) => (value ? "S" : "N");

    setIsSaving(true);
    try {
      const responseColors = await colorService.sendColor(
        Number(idColor),
        group.vehicleGroupId
      );

      const payloadMovement = {
        checkMovWeekdaysFlag: movementForm.weekdays.flag ? "S" : "N",
        checkMovWeekdaysStart: movementForm.weekdays.start,
        checkMovWeekdaysEnd: movementForm.weekdays.end,

        checkMovSaturdayFlag: movementForm.saturday.flag ? "S" : "N",
        checkMovSaturdayStart: movementForm.saturday.start,
        checkMovSaturdayEnd: movementForm.saturday.end,

        checkMovSundayFlag: movementForm.sunday.flag ? "S" : "N",
        checkMovSundayStart: movementForm.sunday.start,
        checkMovSundayEnd: movementForm.sunday.end,

        emailNotificationFlag: movementForm.emailNotificationFlag ? "S" : "N",
        attachmentFormat: movementForm.attachmentFormat,
      };
      const responseMovement = await vehicleGroupService.sendMovement(
        group.vehicleGroupId,
        payloadMovement
      );

      const payloadSpeed = {
        urbanSpeedCheck: speedForm.urban.flag ? "S" : "N",
        urbanSpeedValue: speedForm.urban.value,

        highwaySpeedCheck: speedForm.highway.flag ? "S" : "N",
        highwaySpeedValue: speedForm.highway.value,

        speedEmailCheck: speedForm.emailNotificationFlag ? "S" : "N",
        speedAttachmentFormatCheck: speedForm.attachmentFormat,
      };
      const responseSpeed = await vehicleGroupService.sendSpeed(
        group.vehicleGroupId,
        payloadSpeed
      );

      const payloadKmz = {
        kmzEmailCheck: getFlag(visitFlag),
      };
      const responseKmz = await configsService.sendKmz(
        group.vehicleGroupId,
        payloadKmz
      );

      const payloadVisit = {
        visitEmailCheck: getFlag(visitFlag),
        visitAttachmentFormatCheck: archives.archivePontoDeVista,
      };
      const responseVisit = await configsService.sendVisit(
        group.vehicleGroupId,
        payloadVisit
      );

      const payloadFence = {
        fenceEmailCheck: getFlag(fenceFlag),
        fenceAttachmentFormatCheck: archives.archiveCercaEletronica,
      };
      const responseFence = await configsService.sendFence(
        group.vehicleGroupId,
        payloadFence
      );

      const payloadRiskArea = {
        riskAreaEmailCheck: getFlag(riskAreaFlag),
        riskAreaAttachmentFormatCheck: archives.archiveAreaDeRisco,
      };
      const responseRiskArea = await configsService.sendRiskArea(
        group.vehicleGroupId,
        payloadRiskArea
      );

      const payloadStreches = {
        stretchEmailCheck: getFlag(strechesFlag),
        stretchAttachmentCheck: archives.archiveMovimentacao,
      };
      const responseStreches = await configsService.sendStreches(
        group.vehicleGroupId,
        payloadStreches
      );

      if (
        responseColors &&
        responseSpeed &&
        responseMovement &&
        responseKmz &&
        responseFence &&
        responseVisit &&
        responseRiskArea &&
        responseStreches
      ) {
        setToastParams(
          JSON.stringify({
            show: true,
            title: "Atenção!",
            body: "Configurações atualizadas",
            color: "Success",
          })
        );
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsSaving(false);
    }
  };

  const getEmailContent = (reportKey) => {
    const { email, list, error } = emailsByReport[reportKey] || {
      email: "",
      list: [],
      error: "",
    };

    const handleChange = (e) => {
      setEmailsByReport((prev) => ({
        ...prev,
        [reportKey]: { ...prev[reportKey], email: e.target.value },
      }));
    };

    const handleAdd = async (emailFromList = "") => {
      const trimmedEmail = extractEmailText(emailFromList || email || "").trim();
      const isResend = Boolean(emailFromList);
      if (!trimmedEmail) return;

      if (!isResend && list.some((e) => e.email === trimmedEmail)) {
        setEmailsByReport((prev) => ({
          ...prev,
          [reportKey]: {
            ...prev[reportKey],
            error: "Este email já foi adicionado.",
          },
        }));
        return;
      }

      setLoadingButtons((prev) => ({ ...prev, [reportKey]: true }));

      try {
        const reportTypeObj = REPORT_TYPES.find((t) => t.key === reportKey);
        if (!reportTypeObj) {
          console.error(`Report key "${reportKey}" não encontrado.`);
          return;
        }

        const payload = {
          vehicleGroupId: item.vehicleGroupId,
          codeReport: reportTypeObj.codeReport,
          email: trimmedEmail,
        };

        const created = await configsService.createEmailConfiguration(payload);

        if (!created || created.error) {
          throw new Error("Falha ao adicionar e-mail");
        }

        console.log("E-mail adicionado com sucesso");

        // ✅ Recarrega a lista do backend
        await fetchEmails();

        setEmailsByReport((prev) => ({
          ...prev,
          [reportKey]: {
            ...prev[reportKey],
            email: "",
            error: "",
          },
        }));
      } catch (error) {
        console.error("Erro ao adicionar email:", error);
        setEmailsByReport((prev) => ({
          ...prev,
          [reportKey]: {
            ...prev[reportKey],
            error: "Falha ao adicionar e-mail. Tente novamente.",
          },
        }));
      } finally {
        setLoadingButtons((prev) => ({ ...prev, [reportKey]: false }));
      }
    };

    const handleRemove = async (vehicleGroupEmailId) => {
      try {
        const removed = await configsService.deleteEmailConfiguration(vehicleGroupEmailId);

        if (removed && removed.error) {
          throw new Error("Falha ao remover e-mail");
        }

        // 👇 Atualiza estado local
        setEmailsByReport((prev) => ({
          ...prev,
          [reportKey]: {
            ...prev[reportKey],
            list: prev[reportKey].list.filter(
              (item) => item.id !== vehicleGroupEmailId
            ),
          },
        }));
      } catch (error) {
        console.error("Erro ao remover email:", error);
        // Não exibe erro na tela para respostas 204 / confirmação silenciosa.
      }
    };

    return (
      <div className="row" style={{ marginBottom: 20 }}>
        <div className="col-md-6">
          <div className="input-group mb-2">
            <input
              type="email"
              className="form-control"
              value={email}
              onChange={handleChange}
              placeholder="Digite o e-mail"
            />
            <button
              className="btn btn-primary"
              type="button"
              onClick={(e) => {
                e.preventDefault();
                handleAdd();
              }}
              disabled={loadingButtons[reportKey]}
            >
              {loadingButtons[reportKey] ? (
                <>
                  <span
                    className="spinner-border spinner-border-sm me-2"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  Inserindo...
                </>
              ) : (
                "Inserir"
              )}
            </button>
          </div>
          <span style={{ color: "red", fontSize: 10 }}>{error}</span>

          <ul className="list-group">
            {list.length === 0 ? (
              <li className="list-group-item text-muted" style={{ fontSize: 12 }}>
                Nenhum e-mail cadastrado.
              </li>
            ) : (
              list.map((item) => (
                <li
                  key={item.id}
                  className="list-group-item d-flex align-items-center"
                  style={{
                    gap: "16px",
                  }}
                >
                  <span
                    style={{
                      flex: 1,
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                    }}
                  >
                    {item.email}
                  </span>

                  {item.isValid === "N" ? (
                    <span className="badge bg-warning text-dark">Pendente</span>
                  ) : null}

                  {item.isValid === "S" ? (
                    <IoCheckmarkCircleOutline />
                  ) : (
                    <AiOutlineExclamationCircle />
                  )}
                  <button
                    className="btn btn-sm btn-outline-info"
                    type="button"
                    onClick={(e) => {
                      e.preventDefault();
                      handleAdd(item.email);
                    }}
                  >
                    Reenviar
                  </button>
                  <button
                    className="btn btn-sm btn-outline-danger"
                    type="button"
                    onClick={(e) => {
                      e.preventDefault();
                      handleRemove(item.id);
                    }}
                  >
                    Excluir
                  </button>
                </li>
              ))
            )}
          </ul>
        </div>
      </div>
    );
  };

  const getReportConfigById = (reportId) => {
    return reportConfigPayload.find((item) => item.id === reportId) || {};
  };

  const updateReportConfigById = (reportId, nextValues) => {
    setReportConfigPayload((prev) =>
      prev.map((item) =>
        item.id === reportId ? { ...item, ...nextValues } : item
      )
    );
  };

  const renderReportFrequencyControls = (reportId) => {
    const currentConfig = getReportConfigById(reportId);

    return (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: 12,
          flexWrap: "wrap",
          // marginLeft: 56,
          marginTop: 10,
        }}
      >
        <span>Frequência:</span>
        <div className="form-check">
          <input
            className="form-check-input"
            type="radio"
            name={`frequencia-radio-${reportId}`}
            id={`frequencia-diario-${reportId}`}
            checked={(currentConfig.frequencia || FREQUENCIA.DIARIO) === FREQUENCIA.DIARIO}
            onChange={() =>
              updateReportConfigById(reportId, { frequencia: FREQUENCIA.DIARIO })
            }
          />
          <label htmlFor={`frequencia-diario-${reportId}`} className="form-check-label">
            Diário
          </label>
        </div>
        <div className="form-check">
          <input
            className="form-check-input"
            type="radio"
            name={`frequencia-radio-${reportId}`}
            id={`frequencia-semanal-${reportId}`}
            checked={currentConfig.frequencia === FREQUENCIA.SEMANAL}
            onChange={() =>
              updateReportConfigById(reportId, { frequencia: FREQUENCIA.SEMANAL })
            }
          />
          <label htmlFor={`frequencia-semanal-${reportId}`} className="form-check-label">
            Semanal
          </label>
        </div>
      </div>
    );
  };

  const renderReportExcelControls = (reportId) => {
    const currentConfig = getReportConfigById(reportId);

    return (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: 12,
          flexWrap: "wrap",
          marginLeft: 56,
          marginTop: 10,
        }}
      >
        <span>Excel:</span>
        <div className="form-check">
          <input
            className="form-check-input"
            type="radio"
            name={`excel-radio-${reportId}`}
            id={`excel-aba-unica-${reportId}`}
            checked={(currentConfig.tipoExcel || TIPO_EXCEL.ABA_UNICA) === TIPO_EXCEL.ABA_UNICA}
            onChange={() =>
              updateReportConfigById(reportId, { tipoExcel: TIPO_EXCEL.ABA_UNICA })
            }
          />
          <label htmlFor={`excel-aba-unica-${reportId}`} className="form-check-label">
            Aba única
          </label>
        </div>
        <div className="form-check">
          <input
            className="form-check-input"
            type="radio"
            name={`excel-radio-${reportId}`}
            id={`excel-abas-separadas-${reportId}`}
            checked={currentConfig.tipoExcel === TIPO_EXCEL.ABAS_SEPARADAS}
            onChange={() =>
              updateReportConfigById(reportId, { tipoExcel: TIPO_EXCEL.ABAS_SEPARADAS })
            }
          />
          <label htmlFor={`excel-abas-separadas-${reportId}`} className="form-check-label">
            Abas separadas
          </label>
        </div>
      </div>
    );
  };

  const renderReportFrequencyAndExcelControls = (reportId) => {
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          gap: 28,
          alignItems: "flex-start",
          flexWrap: "wrap",
          marginLeft: 56,
          marginTop: 10,
        }}
      >
        {renderReportFrequencyControls(reportId)}
        {renderReportExcelControls(reportId)}
      </div>
    );
  };

  return (
    <>
      <ToastComponent
        params={toastParams}
        closeToast={() => setToastParams(JSON.stringify({ show: false }))}
      />
      <div
        style={{
          marginLeft: 10,
          marginRight: 10,
          paddingLeft: 20,
          paddingRight: 20,
          paddingTop: 20,
        }}
      >
        {isLoading ? (
          <Spinner />
        ) : (
          <>
            <div className="back-to-fleet" style={{ marginBottom: 8 }}>
              <button
                style={{ display: "flex", alignItems: "center" }}
                onClick={() => handleCancel()}
              >
                <div className="icon-back-fleet">
                  <IoMdArrowBack />
                </div>

                <span>Voltar</span>
              </button>
            </div>
            <div className="">
              <h3 style={{ color: "var(--text-primary)" }}>
                Configurando grupo: {item.vehicleGroupName}
              </h3>
            </div>
            <div className="row">
              <div className="card col-md-12 p-3">
                <h5 className="mb-3">
                  Cor atribuida a todos os veiculos do grupo
                </h5>
                <div className="col-sm-4 d-flex">
                  <select
                    name="colors"
                    className="form-control me-2"
                    onChange={handleChangeCollor}
                    value={selectedId || "0"}
                  >
                    <option value={"0"}>USAR COR DO VEÍCULO</option>
                    {listCollor &&
                      listCollor.map((color, index) => (
                        <option key={index} value={color.colorId}>
                          {color.description}
                        </option>
                      ))}
                  </select>

                  <div
                    style={{
                      display:
                        selectedId == 0 || !selectedId ? "none" : "block",
                      width: "90px",
                      height: "40px",
                      border: "1px solid #ccc",
                      borderRadius: "6px",
                      backgroundColor: selectedColor || "transparent",
                    }}
                  />
                </div>
              </div>

              {/* O restante do seu JSX permanece o mesmo */}
              <div className="card col-md-12 p-3 mt-3">
                <h5 className="mb-3">
                  Parametrização de sinalização de velocidade definida
                </h5>

                <div className="row align-items-center g-2 mb-2">
                  <div className="col-auto">
                    <div className="form-check form-switch">
                      <label
                        className="form-check-label"
                        htmlFor="switchUrbano"
                      >
                        {" "}
                        Limite de velocidade Urbana
                      </label>
                      <input
                        className="form-check-input"
                        type="checkbox"
                        id="switchUrbano"
                        checked={speedForm.urban.flag}
                        onChange={(e) =>
                          setSpeedForm((prev) => ({
                            ...prev,
                            urban: { ...prev.urban, flag: e.target.checked },
                          }))
                        }
                      />
                    </div>
                  </div>
                  <div className="col-auto">
                    <select
                      className="form-control form-control-sm text-center"
                      style={{ width: 50 }}
                      value={speedForm.urban.value}
                      onChange={(e) =>
                        setSpeedForm((prev) => ({
                          ...prev,
                          urban: { ...prev.urban, value: e.target.value },
                        }))
                      }
                    >
                      {optionsUrban.map((num) => (
                        <option key={num} value={num}>
                          {num}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="col-auto">
                    <span className="text-muted small">Km/h</span>
                  </div>
                </div>

                <div className="row align-items-center g-2 mb-2">
                  <div className="col-auto">
                    <div className="form-check form-switch">
                      <label
                        className="form-check-label"
                        htmlFor="switchRodovia"
                      >
                        Limite de velocidade Rodoviária
                      </label>
                      <input
                        className="form-check-input"
                        type="checkbox"
                        id="switchRodovia"
                        checked={speedForm.highway.flag}
                        onChange={(e) =>
                          setSpeedForm((prev) => ({
                            ...prev,
                            highway: {
                              ...prev.highway,
                              flag: e.target.checked,
                            },
                          }))
                        }
                      />
                    </div>
                  </div>
                  <div className="col-auto">
                    <select
                      className="form-control form-control-sm text-center"
                      style={{ width: 45 }}
                      value={speedForm.highway.value}
                      onChange={(e) =>
                        setSpeedForm((prev) => ({
                          ...prev,
                          highway: { ...prev.highway, value: e.target.value },
                        }))
                      }
                    >
                      {optionsRod.map((num) => (
                        <option key={num} value={num}>
                          {num}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="col-auto">
                    <span className="text-muted small">Km/h</span>
                  </div>
                </div>

                <div
                  style={{ display: "flex", alignItems: "center", gap: "10px" }}
                >
                </div>
              </div>

              <div className="card col-md-12 p-3 mt-3">
                <h5 className="mb-3">Parametrização de horário de uso</h5>

                <div className="row align-items-center g-2 mb-2">
                  <div className="col-auto">
                    <div className="form-check form-switch">
                      <label className="form-check-label">
                        De Segunda a Sexta
                      </label>
                      <input
                        className="form-check-input"
                        type="checkbox"
                        checked={movementForm.weekdays.flag}
                        onChange={(e) =>
                          setMovementForm((prev) => ({
                            ...prev,
                            weekdays: {
                              ...prev.weekdays,
                              flag: e.target.checked,
                            },
                          }))
                        }
                      />
                    </div>
                  </div>

                  <div
                    className="col-auto"
                    style={{ marginTop: 5.5, marginLeft: 30 }}
                  >
                    <label className="form-check-label">De:</label>
                  </div>
                  <div className="col-auto d-flex">
                    <input
                      type="time"
                      className="form-control form-control-sm"
                      value={movementForm.weekdays.start}
                      max={movementForm.weekdays.end}
                      onChange={(e) =>
                        setMovementForm((prev) => ({
                          ...prev,
                          weekdays: { ...prev.weekdays, start: e.target.value },
                        }))
                      }
                    />

                    <label
                      className="form-check-label"
                      style={{ margin: "0 10px" }}
                    >
                      Até:
                    </label>

                    <input
                      type="time"
                      className="form-control form-control-sm"
                      value={movementForm.weekdays.end}
                      min={movementForm.weekdays.start}
                      onChange={(e) =>
                        setMovementForm((prev) => ({
                          ...prev,
                          weekdays: { ...prev.weekdays, end: e.target.value },
                        }))
                      }
                    />
                  </div>
                </div>

                <div className="row align-items-center g-2 mb-2">
                  <div className="col-auto">
                    <div className="form-check form-switch">
                      <label className="form-check-label">Sábado</label>
                      <input
                        className="form-check-input"
                        type="checkbox"
                        checked={movementForm.saturday.flag}
                        onChange={(e) =>
                          setMovementForm((prev) => ({
                            ...prev,
                            saturday: {
                              ...prev.saturday,
                              flag: e.target.checked,
                            },
                          }))
                        }
                      />
                    </div>
                  </div>

                  <div
                    className="col-auto"
                    style={{ marginTop: 5.5, marginLeft: 30 }}
                  >
                    <label className="form-check-label">De:</label>
                  </div>
                  <div className="col-auto d-flex">
                    <input
                      type="time"
                      className="form-control form-control-sm"
                      value={movementForm.saturday.start}
                      max={movementForm.saturday.end}
                      onChange={(e) =>
                        setMovementForm((prev) => ({
                          ...prev,
                          saturday: { ...prev.saturday, start: e.target.value },
                        }))
                      }
                    />

                    <label
                      className="form-check-label"
                      style={{ margin: "0 10px" }}
                    >
                      Até:
                    </label>

                    <input
                      type="time"
                      className="form-control form-control-sm"
                      value={movementForm.saturday.end}
                      min={movementForm.saturday.start}
                      onChange={(e) =>
                        setMovementForm((prev) => ({
                          ...prev,
                          saturday: { ...prev.saturday, end: e.target.value },
                        }))
                      }
                    />
                  </div>
                </div>

                <div className="row align-items-center g-2 mb-2">
                  <div className="col-auto">
                    <div className="form-check form-switch">
                      <label className="form-check-label">Domingo</label>
                      <input
                        className="form-check-input"
                        type="checkbox"
                        checked={movementForm.sunday.flag}
                        onChange={(e) =>
                          setMovementForm((prev) => ({
                            ...prev,
                            sunday: { ...prev.sunday, flag: e.target.checked },
                          }))
                        }
                      />
                    </div>
                  </div>

                  <div
                    className="col-auto"
                    style={{ marginTop: 5.5, marginLeft: 30 }}
                  >
                    <label className="form-check-label">De:</label>
                  </div>
                  <div className="col-auto d-flex">
                    <input
                      type="time"
                      className="form-control form-control-sm"
                      value={movementForm.sunday.start}
                      max={movementForm.sunday.end}
                      onChange={(e) =>
                        setMovementForm((prev) => ({
                          ...prev,
                          sunday: { ...prev.sunday, start: e.target.value },
                        }))
                      }
                    />

                    <label
                      className="form-check-label"
                      style={{ margin: "0 10px" }}
                    >
                      Até:
                    </label>

                    <input
                      type="time"
                      className="form-control form-control-sm"
                      value={movementForm.sunday.end}
                      max={movementForm.sunday.start}
                      onChange={(e) =>
                        setMovementForm((prev) => ({
                          ...prev,
                          sunday: { ...prev.sunday, end: e.target.value },
                        }))
                      }
                    />
                  </div>
                </div>

                <div
                  style={{ display: "flex", alignItems: "center", gap: "10px" }}
                >
                </div>
              </div>

              <div className="card col-md-12 p-3 mt-3">
                <h5 className="mb-3">Outros Relatórios</h5>

                <div style={{ marginBottom: 16 }}>
                  <ReportConfigList
                    reportItems={reportItems}
                    initialConfig={initialReportConfig}
                    onChange={(_, payload) => setReportConfigPayload(payload)}
                    showPayloadPreview={false}
                    renderItemContent={(reportItem, config) =>
                      config?.ativo ? (
                        <div style={{ marginLeft: 56, marginTop: 2 }}>
                          {getEmailContent(reportItem.id)}
                        </div>
                      ) : null
                    }
                  />
                </div>

                {SHOW_LEGACY_REPORTS ? (
                  <div style={{ marginTop: 16 }}>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "10px",
                        marginBottom: 10,
                      }}
                    >
                      <div className="form-check form-switch">
                        <label
                          className="form-check-label"
                          htmlFor="switchPontoVista"
                        >
                          Envio de relatório de ponto de visita, controle e passagem
                        </label>
                        <input
                          className="form-check-input"
                          type="checkbox"
                          id="switchPontoVista"
                          checked={visitFlag}
                          onChange={(e) => {
                            handleToggle("pontoDeVista");
                            setVisitFlag(e.target.checked);
                          }}
                        />
                      </div>
                    </div>
                    {relatorios.pontoDeVista ? (
                      <div style={{ marginLeft: 56, marginTop: 2, marginBottom: 12 }}>
                        {getEmailContent("pontoDeVista")}
                      </div>
                    ) : null}

                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "10px",
                        marginBottom: 10,
                      }}
                    >
                      <div className="form-check form-switch">
                        <label
                          className="form-check-label"
                          htmlFor="switchAreaRisco"
                        >
                          Envio de relatório de área de risco
                        </label>
                        <input
                          className="form-check-input"
                          type="checkbox"
                          id="switchAreaRisco"
                          checked={riskAreaFlag}
                          onChange={(e) => {
                            handleToggle("areaDeRisco");
                            setRiskAreaFlag(e.target.checked);
                          }}
                        />
                      </div>
                    </div>
                    {relatorios.areaDeRisco ? (
                      <div style={{ marginLeft: 56, marginTop: 2, marginBottom: 12 }}>
                        {getEmailContent("areaDeRisco")}
                      </div>
                    ) : null}

                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "10px",
                        marginBottom: 10,
                      }}
                    >
                      <div className="form-check form-switch">
                        <label className="form-check-label" htmlFor="switchCerca">
                          Envio de relatório de condução em cerca eletrônica
                        </label>
                        <input
                          className="form-check-input"
                          type="checkbox"
                          id="switchCerca"
                          checked={fenceFlag}
                          onChange={(e) => {
                            handleToggle("cercaEletronica");
                            setFenceFlag(e.target.checked);
                          }}
                        />
                      </div>
                    </div>
                    {relatorios.cercaEletronica ? (
                      <div style={{ marginLeft: 56, marginTop: 2, marginBottom: 12 }}>
                        {getEmailContent("cercaEletronica")}
                      </div>
                    ) : null}
                  </div>
                ) : null}
                <div style={{ marginTop: 16 }}>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: 10,
                    }}
                  >
                    <div>
                      <div className="form-check form-switch">
                        <label className="form-check-label" htmlFor="switch-visitsSummaryXlsPeriod">
                          Relatório de visitas por veículos XLS
                        </label>
                        <input
                          className="form-check-input"
                          type="checkbox"
                          id="switch-visitsSummaryXlsPeriod"
                          checked={!!relatorios.visitsSummaryXlsPeriod}
                          onChange={(e) => {
                            handleToggle("visitsSummaryXlsPeriod");
                            setRelatorios((prev) => ({
                              ...prev,
                              visitsSummaryXlsPeriod: e.target.checked,
                            }));
                          }}
                        />
                      </div>
                      {relatorios.visitsSummaryXlsPeriod ? (
                        <>
                          {renderReportFrequencyAndExcelControls("visitsSummaryXlsPeriod")}
                          <div style={{ marginLeft: 56, marginTop: 8 }}>
                            {getEmailContent("visitsSummaryXlsPeriod")}
                          </div>
                        </>
                      ) : null}

                      <div className="form-check form-switch" style={{ marginTop: 8 }}>
                        <label className="form-check-label" htmlFor="switch-visitsSummaryPdfPeriod">
                          Relatório de visitas por veículos PDF
                        </label>
                        <input
                          className="form-check-input"
                          type="checkbox"
                          id="switch-visitsSummaryPdfPeriod"
                          checked={!!relatorios.visitsSummaryPdfPeriod}
                          onChange={(e) => {
                            handleToggle("visitsSummaryPdfPeriod");
                            setRelatorios((prev) => ({
                              ...prev,
                              visitsSummaryPdfPeriod: e.target.checked,
                            }));
                          }}
                        />
                      </div>
                      {relatorios.visitsSummaryPdfPeriod ? (
                        <>
                          {renderReportFrequencyControls("visitsSummaryPdfPeriod")}
                          <div style={{ marginLeft: 56, marginTop: 8 }}>
                            {getEmailContent("visitsSummaryPdfPeriod")}
                          </div>
                        </>
                      ) : null}
                    </div>

                    <hr style={{ margin: "8px 0" }} />

                    <div>
                      <div className="form-check form-switch">
                        <label className="form-check-label" htmlFor="switch-visitsAmountPdfPeriod">
                          Relatório de veículos por visitas PDF
                        </label>
                        <input
                          className="form-check-input"
                          type="checkbox"
                          id="switch-visitsAmountPdfPeriod"
                          checked={!!relatorios.visitsAmountPdfPeriod}
                          onChange={(e) => {
                            handleToggle("visitsAmountPdfPeriod");
                            setRelatorios((prev) => ({
                              ...prev,
                              visitsAmountPdfPeriod: e.target.checked,
                            }));
                          }}
                        />
                      </div>
                      {relatorios.visitsAmountPdfPeriod ? (
                        <>
                          {renderReportFrequencyControls("visitsAmountPdfPeriod")}
                          <div style={{ marginLeft: 56, marginTop: 8 }}>
                            {getEmailContent("visitsAmountPdfPeriod")}
                          </div>
                        </>
                      ) : null}

                      <div className="form-check form-switch" style={{ marginTop: 8 }}>
                        <label className="form-check-label" htmlFor="switch-visitsAmountXlsPeriod">
                          Relatório de veículos por visitas XLS
                        </label>
                        <input
                          className="form-check-input"
                          type="checkbox"
                          id="switch-visitsAmountXlsPeriod"
                          checked={!!relatorios.visitsAmountXlsPeriod}
                          onChange={(e) => {
                            handleToggle("visitsAmountXlsPeriod");
                            setRelatorios((prev) => ({
                              ...prev,
                              visitsAmountXlsPeriod: e.target.checked,
                            }));
                          }}
                        />
                      </div>
                      {relatorios.visitsAmountXlsPeriod ? (
                        <>
                          {renderReportFrequencyAndExcelControls("visitsAmountXlsPeriod")}
                          <div style={{ marginLeft: 56, marginTop: 8 }}>
                            {getEmailContent("visitsAmountXlsPeriod")}
                          </div>
                        </>
                      ) : null}
                    </div>

                    <hr style={{ margin: "8px 0" }} />

                    <div>
                      <div className="form-check form-switch">
                        <label className="form-check-label" htmlFor="switch-speedSummaryPdfPeriod">
                          Resumo de alta Velocidade em PDF
                        </label>
                        <input
                          className="form-check-input"
                          type="checkbox"
                          id="switch-speedSummaryPdfPeriod"
                          checked={!!relatorios.speedSummaryPdfPeriod}
                          onChange={(e) => {
                            handleToggle("speedSummaryPdfPeriod");
                            setRelatorios((prev) => ({
                              ...prev,
                              speedSummaryPdfPeriod: e.target.checked,
                            }));
                          }}
                        />
                      </div>
                      {relatorios.speedSummaryPdfPeriod ? (
                        <>
                          {renderReportFrequencyControls("speedSummaryPdfPeriod")}
                          <div style={{ marginLeft: 56, marginTop: 8 }}>
                            {getEmailContent("speedSummaryPdfPeriod")}
                          </div>
                        </>
                      ) : null}

                      <div className="form-check form-switch" style={{ marginTop: 8 }}>
                        <label className="form-check-label" htmlFor="switch-speedSummaryXlsPeriod">
                          Resumo de alta Velocidade em XLS
                        </label>
                        <input
                          className="form-check-input"
                          type="checkbox"
                          id="switch-speedSummaryXlsPeriod"
                          checked={!!relatorios.speedSummaryXlsPeriod}
                          onChange={(e) => {
                            handleToggle("speedSummaryXlsPeriod");
                            setRelatorios((prev) => ({
                              ...prev,
                              speedSummaryXlsPeriod: e.target.checked,
                            }));
                          }}
                        />
                      </div>
                      {relatorios.speedSummaryXlsPeriod ? (
                        <>
                          {renderReportFrequencyAndExcelControls("speedSummaryXlsPeriod")}
                          <div style={{ marginLeft: 56, marginTop: 8 }}>
                            {getEmailContent("speedSummaryXlsPeriod")}
                          </div>
                        </>
                      ) : null}
                    </div>

                    <hr style={{ margin: "8px 0" }} />

                    <div>
                      <div className="form-check form-switch">
                        <label className="form-check-label" htmlFor="switch-maintenanceSummaryPdfPeriod">
                          Manutenção PDF
                        </label>
                        <input
                          className="form-check-input"
                          type="checkbox"
                          id="switch-maintenanceSummaryPdfPeriod"
                          checked={!!relatorios.maintenanceSummaryPdfPeriod}
                          onChange={(e) => {
                            handleToggle("maintenanceSummaryPdfPeriod");
                            setRelatorios((prev) => ({
                              ...prev,
                              maintenanceSummaryPdfPeriod: e.target.checked,
                            }));
                          }}
                        />
                      </div>
                      {relatorios.maintenanceSummaryPdfPeriod ? (
                        <>
                          {renderReportFrequencyControls("maintenanceSummaryPdfPeriod")}
                          <div style={{ marginLeft: 56, marginTop: 8 }}>
                            {getEmailContent("maintenanceSummaryPdfPeriod")}
                          </div>
                        </>
                      ) : null}

                      <div className="form-check form-switch" style={{ marginTop: 8 }}>
                        <label className="form-check-label" htmlFor="switch-maintenanceSummaryXlsPeriod">
                          Manutenção XLS
                        </label>
                        <input
                          className="form-check-input"
                          type="checkbox"
                          id="switch-maintenanceSummaryXlsPeriod"
                          checked={!!relatorios.maintenanceSummaryXlsPeriod}
                          onChange={(e) => {
                            handleToggle("maintenanceSummaryXlsPeriod");
                            setRelatorios((prev) => ({
                              ...prev,
                              maintenanceSummaryXlsPeriod: e.target.checked,
                            }));
                          }}
                        />
                      </div>
                      {relatorios.maintenanceSummaryXlsPeriod ? (
                        <>
                          {renderReportFrequencyAndExcelControls("maintenanceSummaryXlsPeriod")}
                          <div style={{ marginLeft: 56, marginTop: 8 }}>
                            {getEmailContent("maintenanceSummaryXlsPeriod")}
                          </div>
                        </>
                      ) : null}
                    </div>
                  </div>
                </div>
              </div>

            </div>
            <div
              style={{
                marginTop: 20,
                textAlign: "right",
                display: "flex",
                gap: 16,
                justifyContent: "end",
              }}
            >
              <button
                className="btn btn-secondary"
                onClick={() => handleCancel()}
              >
                Cancelar
              </button>
              <button
                className="btn btn-primary"
                onClick={() => onSubmit(selectedId)}
                disabled={isSaving}
              >
                {isSaving ? (
                  <>
                    <span
                      className="spinner-border spinner-border-sm me-2"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    Salvando...
                  </>
                ) : (
                  t("BUTTONS.SAVE")
                )}
              </button>
            </div>
          </>
        )}
      </div>
    </>
  );
}